import { useEffect } from 'react';
import { requestLicenses, setLicenses, getLicenses } from 'rdx/modules/licenses/slice';
import { getSessionLink } from 'rdx/modules/auth/slice';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import ResourceList from 'lib/jsonApi/ResourceList';

export function useLicenses() {
  const dispatch = useAppDispatch();

  const link = useAppSelector(getSessionLink('licenses'));

  const licenses = useAppSelector(getLicenses);

  useEffect(() => () => {
    dispatch(setLicenses(new ResourceList()));
  }, [dispatch]);

  useEffect(() => {
    dispatch(requestLicenses({ link }));
  }, [dispatch, link]);

  return licenses ?? [];
}

export default useLicenses;
